module.exports = __webpack_public_path__ + "img/buttons.ba72a9c1.svg";